import { useState } from 'react'

import { AppIcon } from '@/shared/ui/icons'

type AuthAssetSlotProps = {
  src: string
  fallbackIcon: string
  alt?: string
  className?: string
  imageClassName?: string
}

/**
 * Loads a decorative auth asset; falls back to a neutral container + AppIcon when
 * the file is missing or fails to load (placeholder policy).
 */
export function AuthAssetSlot({
  src,
  fallbackIcon,
  alt = '',
  className = 'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-100',
  imageClassName = 'h-10 w-10 object-contain'
}: AuthAssetSlotProps) {
  const [failed, setFailed] = useState(false)

  if (failed) {
    return (
      <div className={className} aria-hidden>
        <AppIcon name={fallbackIcon} size={20} className="text-brand" />
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      aria-hidden={!alt}
      className={imageClassName}
      onError={() => setFailed(true)}
    />
  )
}
